import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MaintenanceComponent } from './containers/maintenance/maintenance.component';
import { MaintenanceGuard } from './guards/maintenance.guard';

const routes: Routes = [
  {
    canActivate: [MaintenanceGuard],
    component: MaintenanceComponent,
    path: 'maintenance',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class CoreRoutingModule {}
